import { render, staticRenderFns } from "./PostponeQuotation.html?vue&type=template&id=247e75f4&scoped=true&"
import script from "./PostponeQuotation.js?vue&type=script&lang=js&"
export * from "./PostponeQuotation.js?vue&type=script&lang=js&"
import style0 from "./PostponeQuotation.scss?vue&type=style&index=0&id=247e75f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247e75f4",
  null
  
)

export default component.exports